export enum UserResumeOrigin {
  CVDESIGNR = 'cvdesignr',
  INTERNAL = 'internal',
}

export enum UserResumeValidationStatus {
  VALIDATED = 'VALIDATED',
  NOT_VALIDATED = 'NOT_VALIDATED',
}

export interface UserResume {
  id: number;
  userId: number;
  fileName?: string | null;
  title?: string | null;
  bio?: string | null;
  parsed: boolean;
  cvdesignrDocumentId?: string | null;
  name?: string | null;
  jobSought?: string | null;
  language?: string | null;
  country?: string | null;
  completion?: number | null;
  status?: UserResumeValidationStatus | null;
  emptyContents: boolean;
  hasTruncation: boolean;
  origin: UserResumeOrigin;
  addviseoResumeId?: string | null;
  featuredAt?: Date | null;
  deletedAt?: Date | null;
  createdAt?: Date;
  updatedAt?: Date;
}
